import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { Icon } from "semantic-ui-react"
import Category from "./category"
import Brands from "./brands"
import { FilterContext } from "../../providers/FilterProvider"
import { device } from "../../theme"
import MobilePriceRange from "../PriceRange/mobilePriceRange"

const Container = styled.div`
  position: fixed;
  z-index: 1000;
  overflow-y: auto;
  background: ${props => props.theme.colors.lightgrey};
  top: 75px;
  left: 0;
  bottom: 0;
  width: 100%;
  transform: ${props =>
    props.isOpen ? "translateX(0%)" : "translateX(-100%)"};
  transition: transform 0.1s ease-in-out;
  padding: 0;

  @media ${device.desktop} {
    display: none;
  }
`

const Content = styled.div`
  position: relative;
  width: 100%;
`

const CloseButton = styled(Icon)`
  background: none !important;
  margin-left: 22px !important;
`

const SortTitle = styled.h3`
  margin: 32px 0 12px 22px;
`

const UL = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin-top: 22px;
`

const LI = styled.li`
  border-top: 1px solid #888;
  padding: 12px 22px;
  margin: 0;

  &:last-of-type {
    border-bottom: 1px solid #888;
  }
`

const LiTitle = styled.p`
  margin: 0;
  font-size: 1.1rem;
`

const Expand = styled.div`
  display: ${props => (props.isOpen ? "block" : "none")};
  margin: 0;
`

const ActiveSpan = styled.span`
  font-size: 14px;
  color: #999;
  margin-left: 4px;
`

const ActiveSort = styled(Icon)`
  color: ${props => props.theme.colors.green};
  margin-left: 12px !important;
`

const CurrentTitle = ({ title, selected }) => (
  <>
    {title} {selected && <ActiveSpan>({selected})</ActiveSpan>}
  </>
)

function MobileSorting({ brands, category, activeCategory, gender, isOpen, setOpen }) {
  const [activeIndex, setIndex] = useState(0)
  const { state, dispatch } = useContext(FilterContext)
  const [active, setActive] = useState("relevans")

  const handleSort = async type => {
    if (type === active) return
    setActive(type)

    let url = `https://static8-api.herokuapp.com/lineout/feed?gender=${
      gender === "herre" ? "male" : "female"
    }&sortBy=${type}&size=20&page=0&category=${category}`

    if (state.selectedBrands.length) {
      const encodeBrands = encodeURIComponent(
        JSON.stringify(state.selectedBrands)
      )
      const activeGender = gender === "herre" ? "men" : "women"
      url = `https://static8-api.herokuapp.com/lineout/search?gender=${activeGender}&sortBy=${type}&size=20&page=0&category=${category}&brands=${encodeBrands}`
    }

    await fetch(url)
      .then(res => res.json())
      .then(e => dispatch({ products: e, sortBy: type }))
      .catch(err => console.log("err", err))

    document.body.scrollTop = 0
  }

  const handleClick = e => {
    if (e === activeIndex) {
      setIndex(0)
      return
    }

    setIndex(e)
  }

  useEffect(() => {
    setIndex(0)
  }, [isOpen])

  return (
    <Container isOpen={isOpen}>
      <Content>
        <CloseButton
          onClick={() => setOpen(false)}
          name="arrow left"
          size="large"
        />
        <UL>
          <LI>
            <LiTitle onClick={() => handleClick(1)}>
              <CurrentTitle title={`Kategori`} selected={activeCategory} />
              <Icon
                name={activeIndex === 1 ? "angle down" : "angle left"}
                style={{ float: "right" }}
              />
            </LiTitle>{" "}
            <Expand isOpen={activeIndex === 1}>
              <Category gender={gender} />
            </Expand>
          </LI>
          <LI>
            <LiTitle onClick={() => handleClick(2)}>
              <CurrentTitle
                title="Mærker"
                selected={
                  state.selectedBrands.length
                    ? `${state.selectedBrands.length}`
                    : ""
                }
              />
              <Icon
                name={activeIndex === 2 ? "angle down" : "angle left"}
                style={{ float: "right" }}
              />
            </LiTitle>{" "}
            <Expand isOpen={activeIndex === 2}>
              <Brands brands={brands} category={category} gender={gender} />
            </Expand>
          </LI>
        </UL>
        <SortTitle>Sorter efter</SortTitle>
        <UL style={{ marginTop: 0 }}>
          <LI onClick={() => handleSort("relevans")}>
            <LiTitle>
              Relevans{" "}
              {active === "relevans" && (
                <ActiveSort size="small" name="check" />
              )}
            </LiTitle>
          </LI>
          <LI onClick={() => handleSort("lowest")}>
            <LiTitle>
              Laveste pris{" "}
              {active === "lowest" && <ActiveSort size="small" name="check" />}
            </LiTitle>
          </LI>
          <LI onClick={() => handleSort("highest")}>
            <LiTitle>
              Højeste pris{" "}
              {active === "highest" && <ActiveSort size="small" name="check" />}
            </LiTitle>
          </LI>
        </UL>
      </Content>
    </Container>
  )
}

export default MobileSorting
